import React from 'react';

const BookIcon = ({ width = 24, height = 24, fill = '#656263' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H16V20H0V0ZM7 2H2V10L4.5 8.5L7 10V2Z"
        fill={fill}
      />
    </svg>
  );
};

export default BookIcon;
